module.exports = __webpack_public_path__ + "media/images/Block_S_Logo-c4795733276d595d265e1d2a18f73b92.svg";